import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    getSpotWidgetData: () => request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/spot/widget/', 'get', null),
    resetSpotFinres: (data) => request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/spot/widget/finance-result/', 'put', data),
    changeSpotSettings: (data) => request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/spot/widget/settings/', 'patch', data),
    getFuturesWidgetData: () => request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/future/widget/', 'get', null),
    resetFuturesFinres: (data) => request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/future/widget/finance-result/', 'put', data),
    changeFuturesSettings: (data) => {
        request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/future/widget/settings/', 'patch', data);
    },
    maDisable: () => {
        request(ServicesEnum.traderProfileV2, '/exchanges/binance/info/future/widget/multi-asset/', 'delete', null);
    },
    getUserMenuData: () => request(ServicesEnum.traderProfileV2, '/navigation/main/menu/', 'get', null),
    getFeaturesFlags: () => request(ServicesEnum.traderProfileV2, '/navigation/main/feature-flags/', 'get', null),
    setAccountBadge: (state) => request(ServicesEnum.traderProfileV2, '/navigation/main/menu/account-badge/', 'post', { state }),
    getTerminalDownloadData: () => request(ServicesEnum.traderProfileV2, '/navigation/pages/terminal/', 'get', null)
};
